import * as React from "react";
import styled from "styled-components";

const StyledCheckbox = styled.div`
  border-radius: ${props => props.theme.borderRadius};
  width: 24px;
  height: 24px;
  position: relative;
  background-color: ${props => props.theme.palette.primary.main};

  svg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 17px;
  }
`;

export const CheckboxCheckedIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <StyledCheckbox>
      <svg width={25} height={18} viewBox="0 0 25 18" {...props}>
        <path
          fill={"#ffffff"}
          d="M23.98 -0.01C23.92 -0.01 23.85 0 23.79 0.01C23.73 0.03 23.67 0.05 23.61 0.07C23.55 0.1 23.49 0.13 23.44 0.17C23.39 0.21 23.34 0.25 23.29 0.29L8 15.59L1.71 9.29C1.52 9.1 1.26 8.99 1 8.99C0.73 8.98 0.47 9.09 0.28 9.28C0.09 9.47 -0.02 9.73 -0.01 10C-0.01 10.26 0.1 10.52 0.29 10.71L7.29 17.71C7.39 17.8 7.5 17.87 7.62 17.92C7.74 17.97 7.87 18 8 18C8.13 18 8.26 17.97 8.38 17.92C8.5 17.87 8.61 17.8 8.71 17.71L24.71 1.71C24.85 1.57 24.95 1.39 24.99 1.19C25.03 0.99 25.01 0.79 24.93 0.6C24.85 0.41 24.72 0.26 24.55 0.15C24.38 0.04 24.18 -0.02 23.98 -0.01L23.98 -0.01Z"
        />
      </svg>
    </StyledCheckbox>
  );
};
